import axiosTokenInstance from "services/api/backoffice";
import {
    BACKOFFICE_LEAD_STATUS,
    BACKOFFICE_LEAD_STATUS_ERROR,
} from "_models/redux/types";

// Action function
export const patchBackofficeLeadStatus = (params) => async (dispatch) => {
    const { lead_id, lead_backoffice_status_id } = params || {};

    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.patch(
            `/api/callcenter/leads/${lead_id}/backoffice-status`,
            { lead_backoffice_status_id }
        );

        const { data, status } = response || {};

        dispatch({
            type: BACKOFFICE_LEAD_STATUS,
            payload: data || {},
            status: status || {},
            method: "patch",
        });
    } catch (e) {
        dispatch({
            type: BACKOFFICE_LEAD_STATUS_ERROR,
            payload: e || {},
        });
    }
};
